
<div class="page-header">
    <a routerLink="/rechten/overzicht" class="page-header__back">
        <i class="fa-regular fa-chevron-left"></i>
    </a>
    <h1 class="page-header__title">{{ "claim-categories.title" | translate }}</h1>
    <div class="page-header__actions"></div>
</div>

<app-claim-category-detail-form [claimCategory]="claimCategory$ | async" (submitted)="submit($event)" [errors]="errors$ | async" [loading]="loading$ | async"/>